import { Box, useStyleConfig } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

const Card = (props) => {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig('Card', { variant });

  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
};

Card.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.func,
};

export default Card;
